import { ServicesEnum } from "../../enums/Services";
import { PageRoutesConstant } from "../router/components/PageRoutes";

export const UsefulLinksConstant = [
  { label: "Home", path: PageRoutesConstant.Home.path },
  { label: "About Us", path: PageRoutesConstant.About.path },
  { label: "Portfolio", path: PageRoutesConstant.Portfolio.path },
  { label: "Career", path: PageRoutesConstant.Career.path },
  { label: "Contact Us", path: PageRoutesConstant.Contact.path },
];

export const ServicesConstant = [
  {
    label: ServicesEnum.WEB_DEVELOPMENT,
    path: PageRoutesConstant.WebDevelopment.path,
  },
  {
    label: ServicesEnum.PRODUCT_DEVELOPMENT,
    path: PageRoutesConstant.ProductDevelopment.path,
  },
  { label: ServicesEnum.UI_UX_DEVELOPMENT, path: PageRoutesConstant.UiUxDesign.path },
];
